import { createFileRoute } from '@tanstack/react-router'

import { announcementLogsSearchSchema } from '@/pages/announcements/announcement-logs-search'

export const Route = createFileRoute('/_layout/announcements/logs')({
  validateSearch: announcementLogsSearchSchema,
})
